(() => {
  if (window.__giestoArketPages) return;window.__giestoArketPages = true;
  // Merchant copy can contain absolute links in either language. Carry the
  // rendered locale through those links, including links inside the shadow header.
  window.addEventListener('click', event => {
    const path = event.composedPath();
    const anchor = path.find(node => node instanceof HTMLAnchorElement);
    if (!anchor || anchor.hasAttribute('download') || path.some(node => node instanceof HTMLButtonElement)) return;
    const href = anchor.getAttribute('href');
    if (!href || href.startsWith('#')) return;
    const url = new URL(anchor.href, location.href);
    if (!['http:', 'https:'].includes(url.protocol)) return;
    if (url.origin !== location.origin && !['giesto.com', 'www.giesto.com', 'giesto-shop.myshopify.com'].includes(url.hostname)) return;
    const pagePath = url.pathname.replace(/^\/(?:en|tr)(?=\/|$)/, '') || '/';
    if (!/^\/(?:$|(?:pages|collections|products|blogs|policies|search|cart|account|checkout)(?:\/|$))/.test(pagePath)) return;
    const english = document.documentElement.lang.toLowerCase().startsWith('en');
    url.pathname = (english ? '/en' : '') + pagePath;
    // Keep local development and dated theme previews in the current storefront.
    anchor.href = location.origin + url.pathname + url.search + url.hash;
  }, true);
  document.addEventListener('input', event => {
    if (!event.target.matches('[data-ga-location-search]')) return;
    const normalize = s => s.normalize('NFKD').replace(/\p{M}/gu, '').toLowerCase().replace(/ı/g, 'i');
    const term = normalize(event.target.value.trim());const region = event.target.closest('.ga-location-index');
    const cards = [...region.querySelectorAll('[data-ga-location]')];cards.forEach(card => {card.hidden = !normalize(card.textContent).includes(term);});
    region.querySelector('[data-ga-location-empty]').hidden = cards.some(card => !card.hidden);
  });
  // The reusable carousel captures pointer events for mouse dragging. Keep the
  // editorial + as a real control instead of letting that capture retarget its
  // click to the track element.
  document.addEventListener('pointerdown', event => {
    if (event.target.closest?.('[data-giesto-lookbook-shop]')) event.stopPropagation();
  }, true);

  document.addEventListener('click', async event => {
    const trigger = event.target.closest?.('[data-giesto-lookbook-shop]');
    if (!(trigger instanceof HTMLButtonElement)) return;

    const root = trigger.closest('[data-giesto-lookbook-carousel]');
    const drawer = root?.querySelector('theme-drawer.ga-lookbook-drawer');
    const panels = drawer ? [...drawer.querySelectorAll('[data-giesto-lookbook-products]')] : [];
    const activePanel = panels.find(panel => panel.dataset.giestoLookbookProducts === trigger.dataset.giestoLookbookShop);
    if (!(drawer instanceof HTMLElement) || !(activePanel instanceof HTMLElement)) return;

    event.preventDefault();
    event.stopPropagation();
    for (const panel of panels) panel.hidden = panel !== activePanel;
    root.querySelectorAll('[data-giesto-lookbook-shop]').forEach(button => {
      button.setAttribute('aria-expanded', String(button.dataset.giestoLookbookShop === trigger.dataset.giestoLookbookShop));
    });

    if (typeof drawer.open !== 'function') await customElements.whenDefined('theme-drawer');
    trigger.focus({ preventScroll: true });
    const content = drawer.querySelector('[data-giesto-lookbook-drawer-content]');
    if (content) content.scrollTop = 0;
    drawer.open?.();
  });

  document.addEventListener('theme-drawer:close', event => {
    if (!event.target.matches?.('theme-drawer.ga-lookbook-drawer')) return;
    const root = event.target.closest('[data-giesto-lookbook-carousel]');
    root?.querySelectorAll('[data-giesto-lookbook-shop]').forEach(button => {
      button.setAttribute('aria-expanded', 'false');
    });
  });

  // The reference closes the complete quick-add stack only after the cart
  // request succeeds. This covers both a nested size choice and a one-variant
  // product added directly from the editorial drawer.
  document.addEventListener('shopify:cart:lines-update', event => {
    if (event.action !== 'add' || !(event.promise instanceof Promise)) return;
    const sourceDrawer = event.target instanceof Element
      ? event.target.closest('theme-drawer.ga-lookbook-drawer')
      : null;
    const drawer = sourceDrawer ?? (document.querySelector('#GiestoStoreSizePicker[data-lookbook][open]')
      ? document.querySelector('theme-drawer.ga-lookbook-drawer[open]')
      : null);
    if (!(drawer instanceof HTMLElement)) return;
    event.promise.then(result => {
      if (!result?.detail?.didError) drawer.close?.();
    }).catch(() => {});
  });

  if (!document.querySelector('[data-ga-map-src]')) return;
  let preferencesAllowed = false;
  function updateMaps(event) {
    const privacy = window.Shopify?.customerPrivacy;
    if (typeof event?.detail?.preferencesAllowed === 'boolean') {
      preferencesAllowed = event.detail.preferencesAllowed;
    } else if (typeof privacy?.preferencesProcessingAllowed === 'function') {
      preferencesAllowed = privacy.preferencesProcessingAllowed();
    }
    document.querySelectorAll('[data-ga-map-src]').forEach(frame => {
      if (preferencesAllowed && !frame.hasAttribute('src')) frame.src = frame.dataset.gaMapSrc;
      if (!preferencesAllowed) frame.removeAttribute('src');
      frame.hidden = !preferencesAllowed;
      frame.nextElementSibling.hidden = preferencesAllowed;
    });
  }
  let loading = false;
  function initializeMaps() {
    updateMaps();
    if (typeof window.Shopify?.customerPrivacy?.preferencesProcessingAllowed === 'function' || loading) return;
    if (typeof window.Shopify?.loadFeatures !== 'function') return;
    loading = true;
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => {
      loading = false;
      if (!error) updateMaps();
    });
  }
  document.addEventListener('visitorConsentCollected', updateMaps);
  window.addEventListener('pageshow', initializeMaps);
  window.addEventListener('load', initializeMaps, {once: true});
  initializeMaps();
})();
